import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import {
  EPISODE_2284_LIST_URL,
  EPISODE_2284_DELETE_URL,
  paginationSize,
  AUTHORIZATION_REPORTS_INCIDENT_REPORT_URL,
} from '../../../../../constants';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../Episode.Styled';
import { renderCellExpand } from '../../../../common/GridCell/GridCellExpand';
import Dialog2284 from '../2284Dialog/Dialog2284';
import {
  get2284Form,
  reset2284Form,
  setAdmitDate,
  setArrestDate,
  setIncidentDate,
  setNew2284Form,
} from '../../../../../redux/episode/2284Tab/2284Form/2284Slice';
import { resetReportingProgram2284OrgAddress } from '../../../../../redux/episode/2284Tab/2284ReportingProgramOrgAddress/2284ReportingProgramOrgAddressSlice';
import { get2284List } from './services/2284ListApi';
import { getIncidentReportPdfForm } from './incidentReportPdfSlice';
import { deleteStopApi } from '../../../../../services/StopApi/StopApi';
import { getContactByUser } from '../../../../Contact/services/contactsApi';

const TwoTwoEightFourList = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [open2284Dialog, setOpen2284Dialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [list2284, setList2284] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const reference2284Data = useSelector((state) => state.reference2284Data);
  const { reportingPrograms } = reference2284Data;

  const getReportingProgramName = (reportingProgramId) => {
    const getReportingProgram = reportingPrograms.find(
      (item) => item.id === reportingProgramId
    );
    return getReportingProgram?.value;
  };

  useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
  }, [user, list2284.page, list2284.pageSize]);

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

  const fetchData = async () => {
    setList2284((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_2284_LIST_URL}/${episodeId}/?PageNumber=${list2284.page}&PageSize=${list2284.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const list2284Data = await get2284List({
      commonParams,
      authorization,
      getReportingProgramName,
    });
    setList2284((prveState) => ({
      ...prveState,
      ...list2284Data,
    }));
  };

  const handle2284List = (rowData) => {
    const cmpIncidentReportlUrl = `${AUTHORIZATION_REPORTS_INCIDENT_REPORT_URL}${rowData?.epdIrId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(get2284Form(rowData));
    setOpen2284Dialog(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
    dispatch(
      getIncidentReportPdfForm({ cmpIncidentReportlUrl, authorization })
    );
  };

  const handleNew2284List = () => {
    dispatch(reset2284Form());
    dispatch(setNew2284Form(true));
    dispatch(resetReportingProgram2284OrgAddress());
    setOpen2284Dialog(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
  };

  const handleDelete2284 = async (params) => {
    if (!window.confirm('Are you sure you want to delete this 2284 Incident Report?')) {
      return;
    }

    const url = `${EPISODE_2284_DELETE_URL}/${params.row.epdIrId}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization }).then((response) => {
      console.log('### delete response');
      console.log(response);
      fetchData();
    }).catch((e) => alert(e));
  };

  const columnsData = [
    ...(user?.contact?.authLock === true ? [{
      field: 'actions',
      headerName: '',
      sortable: false,
      width: 80,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDelete2284(params);
            }}
          >
            <DeleteIcon />
          </IconButton>
        );
      },
    }] : []),
    {
      field: 'epdIrId',
      headerName: '2284 Id',
      sortable: false,
      width: 200,
    },
    {
      field: 'reportingProgramId',
      headerName: 'Reporting Program',
      sortable: false,
      width: 500,
    },
    {
      field: 'orgAddress',
      headerName: 'Org Address',
      sortable: false,
      renderCell: renderCellExpand,
      width: 500,
      flex: 1,
    },
    {
      field: 'admitDate',
      headerName: 'Admit Date',
      type: 'date',
      minWidth: 100,
      flex: 1,
      sortable: false,
    },
  ];

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant="h5">
            To edit 2284 please click on particular row
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant="contained" onClick={() => handleNew2284List()}>
            New 2284
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={list2284.data}
              rowCount={list2284.total}
              rowsPerPageOptions={paginationSize}
              pageSize={list2284.pageSize}
              pagination
              paginationMode="server"
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setList2284((prveState) => ({
                  ...prveState,
                  pageSize: newPageSize,
                }))
              }
              onPageChange={(newPage) => {
                setList2284((prveState) => ({
                  ...prveState,
                  page: newPage + 1,
                }));
              }}
              loading={list2284.isLoading}
              onRowClick={(param) => handle2284List(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
            </div>
          </div>
        </div>    
      </DataGridContainer>
      <Dialog2284
        open={open2284Dialog}
        setOpen={setOpen2284Dialog}
        openBackdrop={openBackdrop}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        fetchData={fetchData}
      />
    </>
  );
};
export default TwoTwoEightFourList;
